import React from 'react';
import Button from './Button';

/**
 * Modal de confirmation réutilisable.
 * Usage :
 *   <ConfirmModal
 *     open={confirmId !== null}
 *     title="Archiver la stratégie ?"
 *     message="Cette action est irréversible."
 *     confirmLabel="Oui, archiver"
 *     danger
 *     onConfirm={() => { doDelete(confirmId); setConfirmId(null); }}
 *     onCancel={() => setConfirmId(null)}
 *   />
 */
export default function ConfirmModal({ open, title, message, confirmLabel = 'Confirmer', cancelLabel = 'Annuler', danger = false, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(7,10,42,.45)', backdropFilter: 'blur(3px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      }}
      onClick={e => { if (e.target === e.currentTarget) onCancel(); }}
    >
      <div style={{
        background: '#fff', borderRadius: 16, padding: '28px 28px 24px',
        maxWidth: 400, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,.18)',
        display: 'flex', flexDirection: 'column', gap: 12,
      }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#111827' }}>{title}</div>
        {message && <div style={{ fontSize: 14, color: '#6B7280', lineHeight: 1.5 }}>{message}</div>}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 6 }}>
          <Button variant="ghost" size="sm" onClick={onCancel}>{cancelLabel}</Button>
          <Button variant={danger ? 'danger' : 'primary'} size="sm" onClick={onConfirm}>{confirmLabel}</Button>
        </div>
      </div>
    </div>
  );
}
